<div *ngIf="loading !== undefined ? loading : (loader.loading$ | async)" [ngClass]="{ cover: cover }">
  <div class="kt-spinner kt-spinner--v2 kt-spinner--lg kt-spinner--brand"></div>
</div>
